export const RADIUS = {
  0: '0',
  card: '4px',
  container: '8px',
  full: '100vmax',
  modal: '16px',
  tag: '2px',
} as const;
